module.exports = __webpack_public_path__ + "img/202409181615254186vx.b735e2ae.jpg";